import { Schemas } from '../../../../../openapi/generated/types';
import { ReservationFlowInvalidRequestError } from '../../../../../interfaces/reservation_flow';

export function isReservationFlowInvalidRequestError(
  error: Schemas.APIError,
): error is ReservationFlowInvalidRequestError {
  // detailsがない場合はReservationFlowInvalidRequestErrorではない
  if (error.details.length === 0) {
    return false;
  }

  // detailsにreservation_flow_invalid_requestが含まれているかどうかで判定する
  // 他のdetailが含まれる可能性があるため、someを利用
  return error.details.some(
    (detail) => detail.type === 'reservation_flow_invalid_request',
  );
}
